import React from 'react';
import style from './styles.module.scss';
import classnames from 'classnames';
import { ColorResult, SliderPicker } from 'react-color';
import { Popover } from 'antd';

type Props = {
  color: string;
  title: string;
  setColor: (c: string) => any;
  suggestions?: string[];
};

export const ColorPicker: React.SFC<Props> = props => {
  const { color, setColor, title } = props;
  // const {suggestions} = props;

  const [showPicker, setShowPicker] = React.useState(false);
  const setHexColor = React.useCallback((c: ColorResult) => setColor(c.hex), [
    setColor,
  ]);

  return (
    <div className={classnames(style.container)}>
      <Popover
        content={
          <SliderPicker
            color={color}
            // colors={suggestions}
            onChange={setHexColor}
          />
        }
        title={title}
        // trigger='click'
        visible={showPicker}
        onVisibleChange={setShowPicker}>
        <button
          className={style.pickerBtn}
          style={{
            backgroundColor: color,
          }}
        />
      </Popover>
    </div>
  );
};
